import React from 'react';
import classNames from 'classnames';
import View from '@loggi/ui/components/view';
import Display from '@loggi/ui/components/display';
import Icon from '@loggi/ui/components/icon';
import Button from '@loggi/ui/components/button';

function getNotificationElement(
  inline,
  wrapClasses,
  displayIcon,
  iconClasses,
  icon,
  text,
  style,
  align,
  size,
  buttonLabel,
  buttonLink
) {
  const classes = classNames(wrapClasses);
  const icoClasses = classNames(iconClasses);
  const hasButton = Boolean(buttonLabel && buttonLink);
  if (inline) {
    return (
      <View className={classes}>
        <View inline>
          <Display when={displayIcon}>
            <Icon className={icoClasses} type={icon} />
          </Display>
          {text}
        </View>
        <Display when={hasButton}>
          <View inline>
            <Button
              value={buttonLabel}
              onClick={buttonLink}
              style="light"
              color={style}
              size={size}
            />
          </View>
        </Display>
      </View>
    );
  }
  return <View>{text}</View>;
}

export { getNotificationElement };
